<template>
  <div>
    <el-dialog append-to-body
               top="5vh"
               :title="title"
               :visible.sync="dialogFormVisible"
               @close="emitClose"
               :close-on-click-modal="false"
               width="700px">
      <el-form :model="dataForm"
               label-position="right"
               ref="formRules"
               label-width="120px"
               size="small">
        <el-form-item label="待办名称："
                      prop="todo_name">
          <el-input v-model="dataForm.todo_name"
                    style="width:250px"
                    placeholder="请输入待办名称"></el-input>
        </el-form-item>
        <el-form-item label="课程状态："
                      prop="status">
          <el-select v-model="dataForm.status"
                     style="width:250px"
                     placeholder="请选择状态"
                     clearable>
            <el-option label="上架"
                       value="1"></el-option>
            <el-option label="下架"
                       value="0"></el-option>

          </el-select>
        </el-form-item>

        <el-form-item label="任务阶段类型："
                      prop="task_stage_type">
          <el-select v-model="dataForm.task_stage_type"
                     style="width:250px"
                     placeholder="请选择状态"
                     clearable>
            <el-option label="代对接"
                       value="51"></el-option>
            <el-option label="匹配中"
                       value="52"></el-option>
            <el-option label="待确认"
                       value="53"></el-option>
            <el-option label="计划中"
                       value="54"></el-option>
            <el-option label="待上课"
                       value="55"></el-option>
            <el-option label="上课中"
                       value="56"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间："
                      prop="start_time_type">
          <div style="display:flex;  align-items: center;  ">
            <el-select v-model="dataForm.start_time_type"
                       style="width:250px"
                       placeholder="请选择状态"
                       clearable>
              <el-option label="选择时间"
                         value="1"></el-option>
              <el-option label="等于关联时间"
                         value="2"></el-option>
            </el-select>
            <el-date-picker v-model="dataForm.start_time_fix_point"
                            v-if="dataForm.start_time_type=='1'"
                            type="date"
                            value-format="timestamp"
                            placeholder="选择日期">
            </el-date-picker>

            <SelectTimeDuration v-model="dataForm.start_time_active_duration"
                                :maxDays="360"
                                style="marginLeft:10px"
                                @change="handleChangeStart"
                                v-if="dataForm.start_time_type=='2'" />
          </div>
        </el-form-item>
        <el-form-item label="截止时间："
                      prop="end_time_type">
          <div style="display:flex;  align-items: center;  ">
            <el-select v-model="dataForm.end_time_type"
                       style="width:250px"
                       placeholder="请选择状态"
                       clearable>
              <el-option label="选择时间"
                         value="1"></el-option>
              <el-option label="等于关联时间"
                         value="2"></el-option>
            </el-select>
            <el-date-picker v-model="dataForm.end_time_fix_point"
                            v-if="dataForm.end_time_type=='1'"
                            type="date"
                            value-format="timestamp"
                            placeholder="选择日期">
            </el-date-picker>
            <SelectTimeDuration v-model="dataForm.end_time_active_duration"
                                :maxDays="360"
                                style="marginLeft:10px"
                                @change="handleChangeEnd"
                                v-if="dataForm.end_time_type=='2'" />
          </div>
        </el-form-item>

      </el-form>
      <div class="footer">
        <el-button @click="emitClose(false)">取消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确定</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import { courseTodoAdd, courseTodoPut } from '@/request/api'
import SelectTimeDuration from '@/components/selectTime/index.vue'
export default {
  components: { SelectTimeDuration },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: () => {
        return '新建'
      },
    },
    detail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    courseId: {
      type: Number,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {
        start_time_type: '1',
        end_time_type: '1',
        start_time_active_duration: 0,
        end_time_active_duration: 0,
      },
      totalStartSeconds: null,
      totalEndSeconds: null,
      timeObjStart: {},
      timeObjEnd: {},
    }
  },
  mounted() {},
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },

    detail: {
      handler(val) {
        if (val) {
          this.$set(this.dataForm, 'todo_name', val.todo_name)
          this.$set(this.dataForm, 'status', val.status + '')
          this.$set(this.dataForm, 'start_time_type', val.start_time_type + '')
          this.$set(this.dataForm, 'end_time_type', val.end_time_type + '')
          this.$set(this.dataForm, 'task_stage_type', val.task_stage_type + '')
          if (this.dataForm.start_time_type == 1) {
            this.$set(
              this.dataForm,
              'start_time_fix_point',
              val.start_time_fix_point
            )
          } else {
            this.$set(
              this.dataForm,
              'start_time_active_duration',
              val.start_time_active_duration / 1000
            )
          }
          if (this.dataForm.end_time_type == 1) {
            this.$set(
              this.dataForm,
              'end_time_fix_point',
              val.end_time_fix_point
            )
          } else {
            this.$set(
              this.dataForm,
              'end_time_active_duration',
              val.end_time_active_duration / 1000
            )
          }
          console.log('this.dataform', this.dataForm)
        }
      },
      // immediate: true,
      // deep: true,
    },
  },
  methods: {
    handleChangeStart(timeObj) {
      this.timeObjStart = timeObj
    },
    handleChangeEnd(timeObj) {
      this.timeObjEnd = timeObj
    },
    emitClose() {
      this.dataForm = {
        start_time_type: '1',
        end_time_type: '1',
        start_time_active_duration: 0,
        end_time_active_duration: 0,
      }
      // this.detail = {}
      this.$refs['formRules'].resetFields()
      this.$emit('close')
    },
    submit(rules) {
      if (this.title == '新建') {
        let query = {
          task_stage_type: this.dataForm.task_stage_type * 1,
          course_id: this.courseId * 1,
          status: this.dataForm.status,
          todo_name: this.dataForm.todo_name,
          start_time_type: this.dataForm.start_time_type * 1,
          end_time_type: this.dataForm.end_time_type * 1,
        }
        if (this.dataForm.start_time_type == '1') {
          query.start_time_fix_point = this.dataForm.start_time_fix_point
        } else if (this.dataForm.start_time_type == '2') {
          if (
            this.dataForm.start_time_active_duration == 0 ||
            this.dataForm.start_time_active_duration == null
          ) {
            query.start_time_active_duration = 1
          } else {
            query.start_time_active_duration =
              this.dataForm.start_time_active_duration * 1000
          }
        }

        if (this.dataForm.end_time_type == '1') {
          query.end_time_fix_point = this.dataForm.end_time_fix_point
        } else if (this.dataForm.end_time_type == '2') {
          if (
            this.dataForm.end_time_active_duration == 0 ||
            this.dataForm.end_time_active_duration == null
          ) {
            query.end_time_active_duration = 1
          } else {
            query.end_time_active_duration =
              this.dataForm.end_time_active_duration * 1000
          }
        }
        courseTodoAdd(query).then((res) => {
          if (res.data.code == 0) {
            this.$emit('submit')
            this.$message.success('操作成功！')
            this.emitClose()
          }
        })
      } else {
        let query = {
          id: this.detail.id,
          status: this.dataForm.status,
          task_stage_type: this.dataForm.task_stage_type * 1,
          course_id: this.courseId * 1,
          todo_name: this.dataForm.todo_name,
          start_time_type: this.dataForm.start_time_type * 1,
          end_time_type: this.dataForm.end_time_type * 1,
        }
        if (this.dataForm.start_time_type == '1') {
          query.start_time_fix_point = this.dataForm.start_time_fix_point
        } else if (this.dataForm.start_time_type == '2') {
          if (
            this.dataForm.start_time_active_duration == 0 ||
            this.dataForm.start_time_active_duration == null
          ) {
            query.start_time_active_duration = 1
          } else {
            query.start_time_active_duration =
              this.dataForm.start_time_active_duration * 1000
          }
        }

        if (this.dataForm.end_time_type == '1') {
          query.end_time_fix_point = this.dataForm.end_time_fix_point
        } else if (this.dataForm.end_time_type == '2') {
          if (
            this.dataForm.end_time_active_duration == 0 ||
            this.dataForm.end_time_active_duration == null
          ) {
            query.end_time_active_duration = 1
          } else {
            query.end_time_active_duration =
              this.dataForm.end_time_active_duration * 1000
          }
        }
        courseTodoPut(query).then((res) => {
          if (res.data.code == 0) {
            this.$emit('submit')
            this.$message.success('操作成功！')
            this.emitClose()
          }
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.content {
}
</style>